module.exports = __webpack_public_path__ + "static/media/mapfre-economics-e-logo.2cf7fb07.svg";